import { ExtendPlainObject } from '../plainObjects/extend.plainObject';
import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SchemaUtil } from '../utils/schema.util';

export class ExtendVisitor extends BaseTransformationVisitor {
    private get _extendTransformation(): ExtendPlainObject {
        return this.transformation as ExtendPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitOutputDefinition(outputDefinitionContext: any): void {
        this._extendTransformation.columns = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
    }
}
